import { render, staticRenderFns } from "./AnnouncementNotifications.vue?vue&type=template&id=22d02380&scoped=true"
import script from "./AnnouncementNotifications.vue?vue&type=script&lang=js"
export * from "./AnnouncementNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d02380",
  null
  
)

export default component.exports